import Swiper from 'swiper'
import { A11y, Navigation } from 'swiper/modules'

document.querySelectorAll('.element-clienttestimonials').forEach((el) => {
  const container = el.querySelector('.swiper')
  const numSlides = el.querySelectorAll('.swiper-slide').length

  if (numSlides > 1) {
    new Swiper(container, {
      slidesPerView: 1,
      slidesPerGroupAuto: true,
      spaceBetween: 32,
      modules: [A11y, Navigation],
      navigation: {
        nextEl: el.querySelector('.slider-button-next'),
        prevEl: el.querySelector('.slider-button-prev'),
      },
      breakpoints: {
        768: {
          slidesPerView: 'auto',
        },
      },
    })
  }
})
